import { copy } from "./shared";
import ThankYouBody from "./ThankYouBody";
import "../templates/Template3.css";
import "./CheckoutTemplate3.css";

export default function ThankYouTemplate3({ data = {} }) {
  const c = copy(data);
  return (
    <div className="clp3-root">
      {/* NAV */}
      <nav>
        <div className="wrap ni">
          <a className="logo cok3-logo">
            {c.logo ? (
              <img src={c.logo} className="site-logo" alt="" />
            ) : (
              <span className="cok3-brandtext">{c.brand}</span>
            )}
          </a>
          <span className="cok3-secure">✓ Order confirmed</span>
        </div>
      </nav>

      {/* BG SHAPES */}
      <div className="hero-bg">
        <div className="sh1"></div>
        <div className="sh2"></div>
      </div>

      {/* HERO */}
      <section className="hero-bg-img cok3-hero" id="home">
        <div className="hero">
          <div className="cok3-hero-content">
            <span className="cok3-eyebrow">Thank you</span>
            <h1 className="ht">
              You're <span className="hl">enrolled</span>
            </h1>
            {c.sub ? <p className="hs">{c.sub}</p> : null}
          </div>
        </div>
      </section>

      {/* FORM + SUMMARY */}
      <div className="wrap">
        <ThankYouBody data={data} p="cok3" c={c} />
      </div>

      {/* FOOTER */}
      <footer>
        <div className="wrap fi2">
          <div className="cok3-foot">{c.guaranteeOn ? c.guarantee : "© " + c.brand}</div>
        </div>
      </footer>
    </div>
  );
}
